<template>
    <div>
        <!-- 收藏提示 -->
        <div
            class="ui-fav"
            v-if="addFa"
        >
            <div class="ui-isF ui-flex">
                <div class="ui-f">
                    <img :src="icon">
                </div>
                <div class="ui-flex1 ui-left">
                    <div class="ui-add">已添加</div>
                    <div class="ui-addList">至 收藏列表</div>
                </div>
                <div class="ui-look">
                    <span
                        class="ui-arr"
                        @click="goFavorite"
                        :clstag="'jr|keycount|yxsc_Discover|favorite_check'"
                    >查看</span>
                </div>
            </div>
        </div>
        <div
            class="favourite"
            ref="favorite"
        >
            <div class="favourite-content ui-flex">
                <router-link
                    v-if="backHome"
                    class="ui-flex1"
                    to="/home"
                >
                    <img
                        class="ui-icon ui-inline"
                        :src="info.back"
                    >
                    <span
                        class="ui-font24 ui-pad8"
                        style="padding-left:0;"
                    >返回首页</span>
                </router-link>
                <div
                    class="ui-flex1"
                    @click="toFavorite"
                    :clstag="'jr|keycount|8530052_contentmore_collect|'+favorite.activityId+''"
                >
                    <img
                        class="ui-icon ui-inline"
                        :src="fa?info.favorited:info.favorite"
                    >
                    <span class="ui-font24 ui-pad8">{{fa?"已收藏":"收藏"}}</span>
                </div>
                <div
                    class="ui-flex1"
                    @click="toShare"
                    :clstag="'jr|keycount|8530052_contentmore_share|share_'+favorite.activityId+''"
                >
                    <img
                        class="ui-icon ui-inline"
                        :src="info.share"
                    >
                    <span class="ui-font24 ui-pad8">分享</span>
                </div>
                <div
                    class="ui-flex1"
                    @click="toTalk"
                    v-if="isShowComment"
                    :clstag="'jr|keycount|8530052_contentmore_comment|talk_'+favorite.activityId+''"
                >
                    <img
                        class="ui-icon ui-inline"
                        :src="info.talk"
                    >
                    <span class="ui-font24 ui-pad8">评论</span>
                </div>
            </div>
        </div>
        <div
            v-if="isIphonex"
            class="act-iphonex"
        ></div>
    </div>
</template>

<script>
import { shareOpen, shareInit } from '@/util/share';
import request from '@/util/request';
import { genLinkBySSR, isIphonex } from '@/util/common';
import { messages } from '@/config';
import login from '@/util/login';
export default {
    name: 'FavoriteBar',
    props: {
        isFavorite: {
            type: Boolean,
            default: false
        },
        favorite: Object,
        shareData: Object,
        talk: String,
        icon: String,
        isShowComment: {
            type: Boolean,
            default: true
        },
        isLogin: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            info: {
                back: require('../assets/arrL.png'),
                favorite: require('../assets/favorite.png'),
                favorited: require('../assets/favorited.png'),
                share: require('../assets/share.png'),
                talk: require('../assets/talk.png')
            },
            data: [],
            backHome: false,
            fa: false,
            addFa: false,
            isIphonex: false
        };
    },
    methods: {
        toFavorite() {
            // 如果this.isFavorite=true接下来要删除收藏活动,反之添加接口;
            let activityId = +this.favorite.activityId || 0;
            this.fa ? this.deleteFavorite(activityId) : this.addFavorite(activityId);
            // this.fa = !this.fa;
        },
        goFavorite() {
            this.$router.push({ path: '/favorite' });
        },
        toShare() {
            console.log('======share=====');
            // let q = this.$route.query;
            let shareData = this.shareData;
            let href = '';
            href = genLinkBySSR('activity');
            console.log(href);
            shareOpen({
                shareURL: href,
                shareImgSrc: shareData.shareImageUrl || 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
                shareTitle: shareData.shareTitle || messages.shareTitle,
                shareDesc: shareData.shareSubTitle || messages.shareDesc,
                shareChannels: ['0', '1', '3']
            });
        },
        toTalk() {
            // this.$parent.$parent.isMask = true;
            // this.$parent.$parent.focusStatus = true;
            // console.log(this.$parent.$parent);
            // this.$parent.$parent.edit();
            this.isLogin ? this.$router.push({ path: '/comment', query: this.$route.query }) : this.toLogin();
        },
        toLogin() {
            login();
        },
        addFavorite(id) {
            console.log(id);
            request.addOrDelActivity({
                data: {
                    activityId: id
                },
                success: rs => {
                    if (rs.issuccess == '1') {
                        console.log(rs);
                        this.addFa = true;
                        this.fa = !this.fa;
                        setTimeout(() => {
                            this.addFa = false;
                        }, 2000);
                    }
                }
            });
        },
        deleteFavorite(id) {
            request.addOrDelActivity({
                data: {
                    activityId: id
                },
                success: () => {
                    this.fa = !this.fa;
                    this.$toast.show({ text: '取消收藏成功' });
                }
            });
        }
    },
    watch: {
        isFavorite(val) {
            this.fa = val;
        }
    },
    mounted() {
        let back = this.$route.query.back;
        this.backHome = back === 'home' ? true : false;
        console.log('======share=====');
        // let q = this.$route.query;
        let href = '';
        href = genLinkBySSR('activity');
        let defaultOption = {
            shareURL: href,
            shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
            shareTitle: messages.shareTitle,
            shareDesc: messages.shareDesc,
            shareChannels: ['0', '1', '3']
        };
        shareInit(defaultOption);
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
@import './../scss/mixin.scss';
.favourite {
    width: 100%;
    background: #ffffff;
    position: relative;
    bottom: 0;
    left: 0;
    box-sizing: content-box;
    padding-bottom: constant(safe-area-inset-bottom) !important;
    padding-bottom: env(safe-area-inset-bottom) !important;
    // border-top: 1px solid #f7f7f7;

    .favourite-content {
        height: $rem100;
    }
}
.ui-font24 {
    font-size: $rem24;
    color: #333333;
    letter-spacing: 0;
}
.act-iphonex {
    height: $rem68;
    width: 100%;
    background: #ffffff;
}
.ui-flex {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.ui-flex1 {
    flex: 1;
}
.ui-left {
    text-align: left;
}
.ui-icon {
    width: $rem48;
    height: $rem48;
}
.ui-inline {
    display: inline-block;
}
.ui-pad8 {
    padding: $rem8;
}
.ui-fav {
    width: 100%;
    height: $rem128;
    padding: 0 $rem24;
    position: absolute;
    top: -$rem160;
}
.ui-fav img {
    width: $rem138;
    height: $rem88;
}
.ui-add {
    font-size: $rem32;
    color: #ffffff;
    letter-spacing: 0;
    padding: $rem8 $rem16;
}
.ui-addList {
    font-size: $rem28;
    color: #999999;
    letter-spacing: 0;
    padding: $rem8 $rem16;
}
.ui-isF {
    background-color: rgba(0, 0, 0, 0.8);
    height: $rem128;
    width: 100%;
    color: #ffffff;
    padding: 0 $rem16;
}
.ui-look {
    font-size: $rem28;
    color: #ffffff;
    letter-spacing: 0;
}
.ui-arr {
    background: url('../assets/arrow.png') no-repeat;
    background-size: $rem12 $rem18;
    background-position: 100% center;
    padding: 0 $rem18;
}
.ui-f {
    background: #ffffff;
}
</style>
